import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const csePasswordInput = {
  backgroundColor: css`var(--cse-password-input-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-password-input-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderWidth: css`var(--cse-password-input-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-password-input-border-color, ${csFormControl.borderColor})`,
  borderColorError: css`var(--cse-password-input-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-password-input-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-password-input-border-radius, ${csFormControl.borderRadius})`,
  color: css`var(--cse-password-input-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-password-input-color-disabled, ${csFormControl.colorDisabled})`,
  height: css`var(--cse-password-input-height, ${csFormControl.height})`,
  fontSize: css`var(--cse-password-input-font-size, ${csFormControl.fontSize})`,
  fontFamily: css`var(--cse-password-input-font-family, ${csFormControl.fontFamily})`,
  paddingInline: css`var(--cse-password-input-padding-x, ${csFormControl.paddingInline})`,
  paddingBlock: css`var(--cse-password-input-padding-y, ${csFormControl.paddingBlock})`,
  outlineFocus: css`var(--cse-password-input-outline-focus, ${csFormControl.outlineFocus})`,

  placeholderColor: css`var(--cse-password-input-placeholder-color, ${csFormControl.placeholderColor})`,
  buttonColor: css`var(--cse-password-input-button-color, ${csColorFunctional.info})`,
  buttonBackgroundColorDisabled: css`var(--cse-password-input-button-background-color-disabled, transparent)`,
}

export const style: CSSResult = css`
  .cse-password-input {
    align-items: center;
    background-color: ${csePasswordInput.backgroundColor};
    border-width: ${csePasswordInput.borderWidth};
    border-color: ${csePasswordInput.borderColor};
    border-style: solid;
    border-radius: ${csePasswordInput.borderRadius};
    display: flex;
    padding-block: ${csePasswordInput.paddingBlock};
    padding-right: 0;
    padding-left: ${csePasswordInput.paddingInline};
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: color, border-color;
  }

  .disabled {
    background-color: ${csePasswordInput.backgroundColorDisabled};
  }

  input {
    all: unset;
    color: ${csePasswordInput.color};
    height: ${csePasswordInput.height};
    font-size: ${csePasswordInput.fontSize};
    font-family: ${csePasswordInput.fontFamily};
    flex: 1;
  }

  cse-icon-button {
    --cse-icon-button-primary-color: ${csePasswordInput.buttonColor};
    --cse-icon-button-background-color-disabled: ${csePasswordInput.buttonBackgroundColorDisabled};
  }

  input::placeholder {
    color: ${csePasswordInput.placeholderColor};
    opacity: 1;
  }

  .cse-password-input.disabled input {
    color: ${csePasswordInput.colorDisabled};
  }

  .cse-password-input:has(input:focus-visible) {
    outline: ${csePasswordInput.outlineFocus};
  }

  .valid-error {
    border-color: ${csePasswordInput.borderColorError};
  }

  .valid-success {
    border-color: ${csePasswordInput.borderColorSuccess};
  }
`
